import React from 'react'
import './footer.scss'

import iconFacebook from '../../../assets/images/icon-facebook.png'
import iconInstagram from '../../../assets/images/icon-instagram.png'
import iconTwitter from '../../../assets/images/icon-twitter.png'
import iconYoutube from '../../../assets/images/icon-youtube.png'
import iconTiktok from '../../../assets/images/icon-tiktok.svg'
import { socialMedia } from '../../../constants/activity-constants'

const Footer = () => {
  return (
    <div className="f-footer">
      <p>Síguenos en:</p>

      <div className="f-footer__redes">
        <a
          onClick={() => {
            try {
              window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing :: footer',
                action: 'click',
                label: 'facebook',
                value: '',
              })
            } catch (error) {
              console.log(error)
            }
          }}
          href={socialMedia.facebook}
          target="_blank"
        >
          <img src={iconFacebook} alt="icon-facebook" />
        </a>

        <a
          onClick={() => {
            try {
              window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing :: footer',
                action: 'click',
                label: 'instagram',
                value: '',
              })
            } catch (error) {
              console.log(error)
            }
          }}
          href={socialMedia.instagram}
          target="_blank"
        >
          <img src={iconInstagram} alt="icon-instagram" />
        </a>
        
        {socialMedia.twitter && (
          <a
            onClick={() => {
              try {
                window.dataLayer.push({
                  event: 'ga_event',
                  category: 'ui :: landing :: footer',
                  action: 'click',
                  label: 'twitter',
                  value: '',
                })
              } catch (error) {
                console.log(error)
              }
            }}
            href={socialMedia.twitter}
            target="_blank"
          >
            <img src={iconTwitter} alt="icon-twitter" />
          </a>
        )}

        <a
          onClick={() => {
            try {
              window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing :: footer',
                action: 'click',
                label: 'youtube',
                value: '',
              })
            } catch (error) {
              console.log(error)
            }
          }}
          href={socialMedia.youtube}
          target="_blank"
        >
          <img src={iconYoutube} alt="icon-youtube" />
        </a>

        <a
          onClick={() => {
            try {
              window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing :: footer',
                action: 'click',
                label: 'tiktok',
                value: '',
              })
            } catch (error) {
              console.log(error)
            }
          }}
          href={socialMedia.tiktok}
          target="_blank"
        >
          <img src={iconTiktok} alt="icon-tiktok" />
        </a>
      </div>
    </div>
  )
}

export default Footer
